<template>
  <v-app>
    <div id="app" class="layout">
      <div class="main-background">
        
      </div>    
      <div v-if="ocupado" class="ocupado">
        <div class="ocupado__logo">

        </div>
        <div class="ocupado__mensaje">
          <h3 class="titulo-h3">{{ mensajeOcupado }}</h3>
        </div>
        <div class="ocupado__animacion">
          <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
        </div>
      </div>
      <div class="header">
        <router-link class="header__logo" :to="{ name: 'home' }" />
        <div class="header__menu">
          <!-- <router-link class="icon-menu icon-menu-sorteo" :to="{ name: 'sorteos' }" /> -->
          <!-- <router-link class="icon-menu icon-menu-factura" :to="{ name: 'subir-factura' }" /> -->
        </div>
        <div class="header__user">
          <div class="header__user-name">
            <p class="header-text">{{ descripcionUsuario }}</p>
          </div>
          <div class="header__user-log-in-out">
            <a v-if="descripcionUsuario" class="header-link" @click="logout()">Salir</a>
            <a v-else class="header-link" @click="login()"></a>
          </div>        
        </div>
      </div>
      
      <div class="barra-progreso" v-if="!this.$store.estadoWifi">
        <icono-progreso tipo="registro" ></icono-progreso>
        <div class="barra-progreso-separador"></div>
        <icono-progreso tipo="informacionBasica" ></icono-progreso>
        <div class="barra-progreso-separador"></div>
        <!-- <icono-progreso tipo="contacto" ></icono-progreso>
        <div class="barra-progreso-separador"></div> -->
        <icono-progreso tipo="direccion" ></icono-progreso>
        <div class="barra-progreso-separador"></div>
        <!-- <icono-progreso tipo="fechaNacimiento" ></icono-progreso>
        <div class="barra-progreso-separador"></div> -->
        <!-- <icono-progreso tipo="estadoCivil" ></icono-progreso>
        <div class="barra-progreso-separador"></div>       -->
        <!-- <icono-progreso tipo="medioTransporte"></icono-progreso>
        <div class="barra-progreso-separador"></div> -->
        <icono-progreso tipo="categorias" ></icono-progreso>
        <div class="barra-progreso-separador"></div>  
        
        <icono-progreso tipo="factura"></icono-progreso>
        <div class="barra-progreso-separador"></div> 
        <!--<Icono-puntos ></Icono-puntos>-->
      </div>
      <v-snackbar v-model="notificacion.visible" :color="notificacion.color" multi-line top :timeout="4000" dark>
        {{notificacion.mensaje}}
      </v-snackbar>
      <div class="container"> 
        <div class="content">
          <transition name="slide" mode="out-in">
            <router-view/>
          </transition>
        </div>
        <div class="footer">  
          <a href="https://www.lacentral.com.co/" target="_blank" class="footer__logo"></a>      
          <div class="footer__contacto">          
            <p class="footer__contacto-direccion">Calle 49 # 21 38</p>
            <p class="footer__contacto-telefono">322 71 17</p>
            <p class="footer__contacto-email">info@lacentral.com.co</p>
          </div>
          <div class="footer__social">
            <a href="https://www.facebook.com/lacentralCC/" target="_blank" class="icon-social icon-social-facebook"/>
            <a href="https://twitter.com/LaCentralCC" target="_blank" class="icon-social icon-social-twitter"/>
            <a href="https://www.instagram.com/lacentralcc/" target="_blank" class="icon-social icon-social-instagram"/>
            <a href="https://www.youtube.com/channel/UCmuIOM7e1klOvZFbjmFjAyg?view_as=subscriber" target="_blank" class="icon-social icon-social-youtube"/>
          </div>
          <a href="http://aliatec.com.co/" target="_blank" class="footer__author"></a>
        </div>    
      </div>    
    </div>
  </v-app>  
</template>

<script>

import IconoProgreso from './components/general/IconoProgreso'
import IconoPuntos from './components/general/IconoPuntos'

export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',      
    }
  },
  computed: {
    ocupado() {
      return this.$store.getters.ocupado
    },
    mensajeOcupado() {
      return this.$store.getters.mensajeOcupado
    },
    descripcionUsuario() {
      if(this.$store.getters.nombre1)
      {
        return 'Hola ' + this.$store.getters.nombre1
      }
      else if(this.$store.getters.userName)
      {
        return this.$store.getters.userName;
      }

      return null;
    },
    notificacion(){
      return this.$store.state.notificacion
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    login() {
      this.$router.push({ name: 'login' })
    }
  },
  created() {
    if(this.$store.dispatch('consultarConfiguracion')) {
      this.$store.dispatch('autoLogin')
      
    }
  },
  components: {
    IconoProgreso: IconoProgreso,
    IconoPuntos: IconoPuntos
  }
}
</script>

<style lang="scss">

.slide-enter{
  opacity: 1;
}

.slide-enter-active {
  animation: slide-in .5s;
}

.slide-leave{
  opacity: 0;
}

.slide-leave-active {
  animation: slide-out .2s;
}


@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateX(-5rem);
  }

  50%{
    opacity: .2;    
  }

  40%{
    transform: translateX(.5rem);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-out {
  0% {
    opacity: 1;
    transform: translateX(0);
  }

  50%{
    opacity: 0;
  }

  100% {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
</style>
